import React, { useId, useRef } from "react";
import { useFocusTrap } from "../hooks/useFocusTrap";

export default function Modal({ open, onClose, title, imgSrc }:{ open:boolean; onClose:()=>void; title:string; imgSrc:string; }) {
  const modalRef = useRef<HTMLDivElement>(null);
  const titleId = useId();
  useFocusTrap(open, modalRef, { onEscape: onClose });

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        ref={modalRef}
        className="w-full max-w-lg rounded-xl bg-white p-4 shadow-xl"
        onClick={(e)=>e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div id={titleId} className="mb-3 text-lg font-semibold">{title}</div>
        <img src={imgSrc} alt={title} className="w-full rounded-md border" />
        <div className="mt-3 text-right"><button className="rounded-md border px-3 py-1" onClick={onClose}>Close</button></div>
      </div>
    </div>
  );
}
